<template>
			 <el-pagination
				  @size-change="handleSizeChange"
				  @current-change="handleCurrentChange"
				  :current-page="page"
				  :page-sizes="[10, 20, 30]"
				  :page-size="size"
				  layout="total, sizes, prev, pager, next, jumper"
				  :total="total">
				</el-pagination>
</template>

<script>
	export default{
		name:'basePagination',
		data(){
			return{
				
				
			}
		},
		props:{
			total:{
				type:[Number,String],
				default:0
			},
			page:{
				type:[Number,String],
				default:1
			},
			size:{
				type:[Number,String],
				default:10
			}
			
			
		},
		methods:{
			handleSizeChange(e){
				this.$emit("SizeChange",{size:e,page:1})
			},
			handleCurrentChange(e){
				this.$emit("CurrentChange",{page:e,size:this.size})
			},
			
		}
	}
	
	
</script>


// WEBPACK FOOTER //
// src/components/base/basePagination/basePagination.vue